import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const SwipeIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <svg width={size} height={size} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3327 11.6666H1.66602V8.33324H0.332682V12.3332C0.332682 12.5101 0.402919 12.6796 0.527944 12.8046C0.652967 12.9297 0.822537 12.9999 0.999349 12.9999H12.9993C13.1762 12.9999 13.3457 12.9297 13.4708 12.8046C13.5958 12.6796 13.666 12.5101 13.666 12.3332V8.33324H12.3327V11.6666ZM4.21801 3.66658L6.85135 1.03324L5.90868 0.0905762L1.66602 4.33324L5.90868 8.57591L6.85135 7.63324L4.21801 4.99991H11.666V3.66658H4.21801Z" fill={color} />
    </svg>
  </WithIconRounded>
);

SwipeIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

SwipeIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: 'var(--k-ds-color-interactive-primary)',
  containerColor: undefined,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default SwipeIcon;
